export type DatePreset =
  | 'month-to-date'
  | 'one-month-ago'
  | 'two-months-ago'
  | '7-days'
  | '30-days'
  | '90-days';

export const DATE_PRESETS = [
  'month-to-date',
  'one-month-ago',
  'two-months-ago',
  '7-days',
  '30-days',
  '90-days',
];

export function isOfTypeDatePreset(keyInput: string): keyInput is DatePreset {
  return DATE_PRESETS.includes(keyInput);
}
